import axios from 'axios';
import qs from 'qs';
import { createStore } from 'vuex';

const request = axios.create({
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [(data, headers) => {
        return qs.stringify(data)
    }]
});

const state = {
    loading: false, // If search is in progress
    searchFilters: {
        query: '',
        ships_internationally: 0,
        countries: [
        ],
        minimum_order_value: -1, // Doesn't matter
        types: [
            // Dropshippers
            // Wholesalers
            // Liquidators
            // Manufacturers
        ]
    },
    query: '', // The query string for display purposes, no model binding and not reactive
    suppliers: [],
    total: 0, // Total search results count,
    userCountryCode: ''
};

const getters = {
    hasSearchResults(state) {
        if (state.loading) {
            return true;
        }
        return state.suppliers.length > 0;
    },
    getSearchFilter: (state) => (property) => {
        return state.searchFilters[property];
    }
};

const actions = {
    async searchSuppliers({commit, state}, loadingState = true) {
        commit('loading', loadingState);

        let searchFilters = [];
        for (const [key, value] of Object.entries(state.searchFilters)) {
            if (Array.isArray(value)) {
                for (const val of value) {
                    searchFilters.push(`${key}[]=${val}`);        
                }
            } else {
                searchFilters.push(`${key}=${value}`);    
            }
        }

        let url = `/directory/demo-search?` + searchFilters.join('&');
        return await request.get(url)
            .then((response) => {
                commit('suppliers', response.data.results);
                commit('total', response.data.count);
                commit('query', state.searchFilters.query);
                commit('loading', false);
            })
            .catch((error) => {
                commit('loading', false);
            });
    },
};

const mutations = {
    searchFilters(state, payload) {
        state.searchFilters[payload.property] = payload.value;
    },
    suppliers(state, value) {
        state.suppliers = value;
    },
    loading(state, value) {
        state.loading = value;
    },
    query(state, value) {
        state.query = value;
    },
    total(state, value) {
        state.total = value;
    },
    userCountryCode(state, value) {
        state.userCountryCode = value;
    },
};

const store = createStore({
    state,
    getters,
    actions,
    mutations
});

export default store;
